<template>
	<div id="app">
		<router-view />
		<yq-dialog-hint :showDialog.sync="showDialog" :config="dialogConfig" @defined="definedBack"></yq-dialog-hint>
	</div>
</template>

<script>
import { mapState, mapMutations, mapActions, mapGetters } from 'vuex'
import mixinDialog from '@/mixins/mixinsDialog.js'

export default {
	name: 'App',
	mixins: [mixinDialog],
	data () {
		return {}
	},
	computed: {
		...mapState(['globals', 'confirmLogin'])
	},
	mounted () {
		// this.getExplore()
	},
	watch: {
		confirmLogin (newVal, oldVal) {
			if (newVal) {
				this.openErrDialog('warn', '操作信息提示', 'reLogin', '', '登录超时，是否重新登录？', '确定')
			} else {
				this.showDialog = false
			}
		}
	},
	methods: {
		reLogin () {
			//401跳转
			this.$router.push({ name: 'login', qurey: { redirect: window.location.href } })
		},

		umpWebsite () {
			this.$router.push({
				name: 'console'
			})
		},
		// getExplore () {
		// 	let Sys = {}, s = undefined
		// 	let ua = navigator.userAgent.toLowerCase()
		// 	(s = ua.match(/rv:([\d.]+)\) like gecko/)) ? Sys.ie = s[1] :
		// 		(s = ua.match(/msie ([\d\.]+)/)) ? Sys.ie = s[1] :
		// 			(s = ua.match(/edge\/([\d\.]+)/)) ? Sys.edge = s[1] :
		// 				(s = ua.match(/firefox\/([\d\.]+)/)) ? Sys.firefox = s[1] :
		// 					(s = ua.match(/(?:opera|opr).([\d\.]+)/)) ? Sys.opera = s[1] :
		// 						(s = ua.match(/chrome\/([\d\.]+)/)) ? Sys.chrome = s[1] :
		// 							(s = ua.match(/version\/([\d\.]+).*safari/)) ? Sys.safari = s[1] : 0
		// 	// 根据关系进行判断
		// 	if (Sys.ie) return {
		// 		brower: 'IE',
		// 		sys: Sys.ie
		// 	}
		// 	if (Sys.edge) return {
		// 		brower: 'EDGE',
		// 		sys: Sys.edge
		// 	}
		// 	if (Sys.firefox) return {
		// 		brower: 'Firefox',
		// 		sys: Sys.firefox
		// 	}
		// 	if (Sys.chrome) return {
		// 		brower: 'Chrome',
		// 		sys: Sys.chrome
		// 	}
		// 	if (Sys.opera) return {
		// 		brower: 'Opera',
		// 		sys: Sys.opera
		// 	}
		// 	if (Sys.safari) return {
		// 		brower: 'Safari',
		// 		sys: Sys.safari
		// 	}
		// 	return 'Unkonwn'
		// }
	}
}

</script>
<style lang="scss">
#app {
	height: 100%;
}
</style>
